import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollCategoryHistoryEntry  {
    _originalTypeClassName = "zERP.BO.PayrollCategoryHistoryEntry";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollCategoryHistoryEntry.translate = translateService;
}
this.Id = null;
this.Level = null;
this.StartDate = null;
this.EndDate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Level:any;
StartDate:any;
EndDate:any;
PayrollCategory:any;
static setPayrollCategory = ($this, value) => {
var oldValue = $this.PayrollCategory;
$this.PayrollCategory = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}